import React from "react";
import {
  SELECTED_ELEMENT_COLOR,
  defaultObjectSizes,
  OBJECT_TYPES,
} from "../configuratorConstants";
import { ReactComponent as ToiletIcon } from "../../Assets/toilet.svg";

const ToiletRenderer = ({
  element,
  scale,
  isSelected,
  wallThickness,
  placementSideFactor,
  orientation,
}) => {
  const defaults = defaultObjectSizes[OBJECT_TYPES.TOILET];
  const elementVisualWidthM = element.width || defaults.width;
  const elementPlanDepthM = element.depth || defaults.depth;

  const elementVisualWidthPx = elementVisualWidthM * scale;
  const elementPlanDepthPx = elementPlanDepthM * scale;
  const wallThicknessPx = wallThickness * scale;

  const yOffset =
    placementSideFactor * (wallThicknessPx / 2 + elementPlanDepthPx / 2);

  // --- НАЧАЛО ИЗМЕНЕНИЯ: Обновлены стили и пропорции ---
 const iconStyle = {
    fill: isSelected ? "rgba(0, 123, 255, 0.15)" : "#E5E7EB", // Сплошная светло-серая заливка
    stroke: isSelected ? SELECTED_ELEMENT_COLOR : "#4B5563",   // Более темная обводка
    strokeWidth: isSelected ? 1.2 : 0.9,
    pointerEvents: "none",
  };

  let rotationAngle;
  if (orientation === 'v') {
    // Для вертикальных стен: правильная ориентация
    rotationAngle = placementSideFactor === 1 ? 90 : -90;
  } else { 
    // Для горизонтальных стен: поворачиваем чтобы спина была к стене
    rotationAngle = placementSideFactor === 1 ? 90 : -90;
  }
  // --- КОНЕЦ ИЗМЕНЕНИЯ ---

  const groupTransform = `translate(0, ${yOffset}) rotate(${rotationAngle})`;

  return (
    <g transform={groupTransform}>
      <rect
        x={-elementVisualWidthPx / 2}
        y={-elementPlanDepthPx / 2}
        width={elementVisualWidthPx}
        height={elementPlanDepthPx}
        fill="transparent"
      />
      
      <ToiletIcon
        x={-elementVisualWidthPx / 1.1}
        y={-elementPlanDepthPx / 2}
        width={elementVisualWidthPx * 1.4}
        height={elementPlanDepthPx}
        style={iconStyle}
        // --- ИЗМЕНЕНИЕ: Сохранение пропорций ---
        preserveAspectRatio="xMidYMid meet"
      />
    </g>
  );
};

export default React.memo(ToiletRenderer);